import { render } from "./TalentForm.vue?vue&type=template&id=10eb1b96&scoped=true"
import script from "./TalentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TalentForm.vue?vue&type=script&setup=true&lang=js"

import "./TalentForm.vue?vue&type=style&index=0&id=10eb1b96&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10eb1b96"],['__file',"src/views/recruitment/talent/TalentForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10eb1b96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10eb1b96', __exports__)) {
    console.log('reload')
    api.reload('10eb1b96', __exports__)
  }
  
  module.hot.accept("./TalentForm.vue?vue&type=template&id=10eb1b96&scoped=true", () => {
    console.log('re-render')
    api.rerender('10eb1b96', render)
  })

}


export default __exports__